export const ATF_URL_KEY = 'atf' as const;
export const PUBLISHER_JSON_KEY = 'pj' as const;
export const BTR_JSON_KEY = 'c' as const;

export const evaluateShouldAppendABPTag = ({ abpAcceptable = 'false', abpStatus = '-1' }) =>
    abpAcceptable === 'true' && (abpStatus === '1' || abpStatus === '-1');
